import React from "react";
import { Link } from "react-router-dom";
import "../assets/Css/login.css";
import { loginimg, loginlog, logo } from "../Constant/Index";

function Login() {
	return (
		<>
			{/* Login Section */}
			<section className="login_sec overflow-hidden">
				<div className="row align-items-center">
					<div className="col-lg-6">
						<div className="auth_form">
							{/* <div className="mobileLogo">
                <Link to="/">
                  <figure>
                    <img src={logo} alt="weblogo" className="img-fluid" />
                    dddd
                  </figure>
                </Link>
              </div> */}
							<div className="heading_wrapper">
								<div className="webLogo">
									<Link to="/">
										<figure>
											<img src={loginlog} alt="weblogo" className="img-fluid" />
										</figure>
									</Link>
								</div>
								<p className="tagline secondary-color font-weight-bold">
									Powerful Hand
								</p>

								<h2 className="title primary-color">Sign In</h2>
								<p className="primary-color font-weight-meduim">
									Welcome to Powerful Hand, your multi-lingual E-Commerce
									destination for ritual and spiritual products. From candles to
									sacred herbs, we offer a diverse range catering to global
									practices.
								</p>
							</div>
							<form>
								<div className="form-group">
									<input
										type="text"
										placeholder="Email"
										name="email"
										className="form-control"
									/>
								</div>
								<div className="form-group">
									<input
										type="password"
										placeholder="Password"
										name="password"
										// onChange={(e) => setPassword(e.target.value)}
										className="form-control"
									/>
								</div>
								<div className="remeberDv">
									<div className="form-group ">
										<input
											// checked={Boolean(remember)}
											type="checkbox"
											id="remeber_me"
										/>
										<label htmlFor="remeber_me">Remember Me</label>
									</div>
									<div className="forgot">
										<Link to="/forgot-password">Forgot Password ?</Link>
									</div>
								</div>
								<div className="button-group">
									<button className="milkyBtn w-100">
										{" "}
										<Link to="/my-profile"> Sign In</Link>{" "}
									</button>
								</div>
								<div className="signup-span">
									<p className="primary-color font-weight-semibold">
										Dont Have An Account ?{" "}
										<span>
											<Link to="/sign-up">Sign Up</Link>
										</span>
									</p>
								</div>
							</form>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="showcase_column">
							{/* <div className="webLogo">
                <Link to="/">
                  <figure>
                    <img src={loginimg} alt="weblogo" className="img-fluid" />
                  </figure>
                </Link>
              </div> */}
						</div>
					</div>
				</div>
			</section>
			{/* {/ Login Sec End Here /} */}
		</>
	);
}

export default Login;
